var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"copyable"},[_c('a',{class:_vm.copied ? 'hidden' : '',domProps:{"textContent":_vm._s(_vm.labelBefore)},on:{"click":_vm.copy}}),(_vm.copied)?_c('span',{domProps:{"textContent":_vm._s(_vm.labelAfter)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }